import {mapActions} from 'vuex'
import {ACTION_REMOVE_CASE_MULTISELECT_ITEM} from '../../../store/forms/case-form-state'
import {
  ObjectModelToArrayModel,
  injectCategoryIdToConditions,
  smdSelectModelReducer
} from '../../../utilities/utilityOperators'
import {getMapFn} from "../../../store/modules/referencedata2";

export default {
  methods: {
    ...mapActions({
      doRemoveMultiSelectItem: ACTION_REMOVE_CASE_MULTISELECT_ITEM
    }),
    generateMultiSelectModel() {
      const raw = this.getRawModelForMultiSelect();
      const conditionsMapFn = this.getMultiSelectConditionsMapFn();
      return ObjectModelToArrayModel(raw, conditionsMapFn)
    },
    getMultiSelectConditionsMapFn() {
      return getMapFn(this.$options.multiSelectConditionsLookupName);
    },
    getRawModelForMultiSelect() {
      return null;
    },
    removeMultiSelectItem(conditionId) {
      this.doRemoveMultiSelectItem({section: this.$options.multiSelectFormSection, conditionId});
    },
    transformMultiSelectModel(v) {
      return v.reduce(smdSelectModelReducer, {});
    }
  },
  created() {
    if(!this.$options.noDefaultMultiSelectLookup) {
      const mapFn = getMapFn(this.$options.multiSelectLookupName);
      this.mutiSelectLookup = injectCategoryIdToConditions(mapFn)();
    }
  },
  multiSelectFormSection: null,
  multiSelectLookupName: null,
  multiSelectConditionsLookupName: null,
  noDefaultMultiSelectLookup: false
}
